const solutionList = [
    {
        imgPo: "imgLeft",
        type: "Behavioral intelligence recognition",
        name: "",
        title: "Behavioral intelligence recognition",
        img: "/static/img/product/a1.jpg",
        point: [],
        label:'behavioral',
        desc:'',
        fc: [
          
        ],
        btn: {
            show: true,
            text: "view details",
        },
        param: [
        ],
    },
    {
        imgPo: "imgLeft",
        type: "Intelligent monitoring and analysis of production process",
        label:'flow',
        name: "",
        title: "Intelligent monitoring and analysis of production process",
        img: "/static/img/product/flow.png",
        point: [],
        desc:'',
        fc: [
          
        ],
        btn: {
            show: true,
            text: "view details",
        },
        param: [
        ],
    },
];

export default solutionList;
